<template>
<div class="container px-0">
    <div class="row" v-if="loading">
        <div class="col-12">
            <loader></loader>
        </div>
    </div>
    
    <div></div>
    <div id="questionnaire-list-accordion" class="accordion">
        <collapsable
            :title="section.title"
            accordion="#questionnaire-list-accordion"
            :key="index"
            :show="false"
            v-for="(section, index) in sections"
        >
            <template slot="header_content">
                <div class="badge badge--sm badge--primary">{{numSubmissions(section)}}</div>
            </template>

            <template slot="content">
                <list-item v-for="location in section.locations" :key="location.id" @click="openLocation(location)">
                    <template slot="title">
                        <div>
                            <h5>{{location.name}}</h5>
                            <h6>{{getLocationSubtitle(location)}}</h6>
                        </div>
                    </template>
                    <template slot="center">
                        <div class="badge badge--sm badge--primary">{{getLocationNumSubmissions(location)}}</div>
                    </template>
                </list-item>

                <div v-if="!section.locations.length" class="flex-row">
                    <h6 class="flex-table--cell text-light">No submissions</h6>
                </div>
            </template>
        </collapsable>
    </div>
</div>
</template>

<script>
	import Collapsable from "../ListComponent/Collapsable";
	import GalleryViewComponent from "../general_components/GalleryViewComponent";
    import Loader from "../general_components/Loader";
    export default {
        name: "JobQualityAssuranceComplianceChecks",
		components: {GalleryViewComponent, Collapsable, Loader},
        props: {
            load_url: {
				type: String,
				required: true
			},
			show_location_url: {
				type: String,
				required: true
			},
			back_url: {
				type: String,
				required: true
			}
        },

        data(){
		    return {
		        loading: false,
                sections: [],
            }
        },

        mounted() {
            this.load();
        },

        methods: {
            load(){
                let _this = this;
                if (_this.loading){
                    return;
                }

                _this.loading = true;

                axios.get(_this.load_url)
                    .then(function (response){
                        _this.sections = response.data.sections;
                        console.log(_this.sections)
                        _this.loading = false;
                    });
            },
            numSubmissions(section){
				let num_subs = 0;

				section.locations.forEach(location => {
					num_subs += location.question_answers_groups.length;
				});
				return num_subs;
			},

			getLocationSubtitle(location){
				if (location.level.trim() && location.type)
					return 'Level: ' + location.level + ' / Type: ' + location.type;

				if (location.level.trim())
					return 'Level: ' + location.level
				else if (location.room_type)
					return 'Type: ' + location.type

				return null;
			},

			getLocationNumSubmissions(location){
				return location.question_answers_groups.length;
			},

			openLocation(location){
				window.location.href = this.show_location_url.replace('?', location.id);
			}
        }
	}
</script>